module.exports = __webpack_public_path__ + "static/media/arrows-shrink-v.f8574b00.svg";